import { IOrderDetails } from '@/models/orders.model';
import { TUpdateOrderClientFormValues, UpdateOrderClientFormFieldsNames } from '.';

export const getClientFormValues = (order: IOrderDetails | null): TUpdateOrderClientFormValues | undefined => {
  if (order) {
    const result: TUpdateOrderClientFormValues = {
      [UpdateOrderClientFormFieldsNames.NAME]: order.contact_name,
      [UpdateOrderClientFormFieldsNames.PHONE]: order.contact_phone,
      [UpdateOrderClientFormFieldsNames.EMAIL]: order.contact_email,
      [UpdateOrderClientFormFieldsNames.DESCRIPTION]: order.description,
    };

    return result;
  }
};
